import {
	MimaButton,
	MimaInput,
	MimaText,
	Modal,
	MimaTextArea,
	MimaDropdown,
	MimaDateInput,
} from '../../components';
import { appStore } from '../../stores';
import { Formik } from 'formik';
import React from 'react';

const EditVendor = ({
	closeModal,
	vendorDetailsValidation,
	onSubmit,
	loading,
	vendor,
	goBack,
}) => {

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitle" color="var(--color-primary)" align="center">
				Update Vendor
			</MimaText>
			<Formik
				initialValues={{
					name: vendor.name,
					mobile: vendor.mobile,
					email: vendor.email,
					services: vendor.services,
					address: vendor.address,
					secondaryMobile: vendor.secondaryMobile,
					businessCategory: vendor.businessCategory._id,
					relationshipStartDate: vendor.relationshipStartDate ? new Date(vendor.relationshipStartDate) : "",
					contactPersonName: vendor.contactPersonName,
					contactPersonEmail: vendor.contactPersonEmail,
					contactPersonPhone: vendor.contactPersonPhone,
					instagramHandle: vendor.instagramHandle,
					website: vendor.website,
				}}
				validationSchema={vendorDetailsValidation()}
				onSubmit={onSubmit}
			>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<div>
						<MimaInput
							type="text"
							labelTitle="Name"
							placeholder="Enter Vendor Name"
							name="name"
							mb={2}
							value={values.name}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.name}
							touched={touched.name}
						/>

						<MimaInput
							type="text"
							labelTitle="Phone Number"
							placeholder="Vendor Phone number"
							name="mobile"
							mb={2}
							value={values.mobile}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.mobile}
							touched={touched.mobile}
						/>
						<MimaInput
							type="email"
							labelTitle="Email Address"
							placeholder=" Vendor Email"
							name="email"
							mb={2}
							value={values.email}
							onChange={handleChange}
							onBlur={handleBlur}
						/>

						<MimaDropdown
							labelTitle="Business Category"
							onChange={data => {
								setFieldValue('businessCategory', data.key);
							}}
							currentValue={vendor.businessCategory?.name}
							placeholder={vendor.businessCategory?.name}
							data={appStore.businessCategories}
							name="businessCategory"
							error={errors.businessCategory}
							touched={touched.businessCategory}
						/>

						<MimaTextArea
							type="textarea"
							labelTitle="Vendor Address"
							placeholder="Vendor's Address"
							name="address"
							mb={2}
							variant="message"
							value={values.address}
							onChange={handleChange}
							onBlur={handleBlur}
						/>
						<MimaTextArea
							type="textarea"
							labelTitle="Vendor Services"
							placeholder="Vendor's Services"
							name="services"
							mb={2}
							variant="message"
							value={values.services}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.services}
							touched={touched.services}
						/>
						<MimaInput
							type="text"
							labelTitle="Secondary Phone Number"
							name="secondaryMobile"
							mb={2}
							value={values.secondaryMobile}
							onChange={handleChange}
							onBlur={handleBlur}
						/>
						<MimaInput
							type="text"
							labelTitle="Website"
							name="website"
							mb={2}
							value={values.website}
							onChange={handleChange}
							onBlur={handleBlur}
						/>
						<MimaInput
							type="text"
							labelTitle="Instagram Handle"
							name="instagramHandle"
							mb={2}
							value={values.instagramHandle}
							onChange={handleChange}
							onBlur={handleBlur}
						/>
						<MimaDateInput
							labelTitle="Relationship Start Date"
							name="relationshipStartDate"
							value={values.relationshipStartDate}
							onChange={text => {
								setFieldValue('relationshipStartDate', text);
							}}
							onBlur={handleBlur}
							width={38}
						/>
						<MimaInput
							type="text"
							labelTitle="Contact Person Name"
							name="contactPersonName"
							mb={2}
							value={values.contactPersonName}
							onChange={handleChange}
							onBlur={handleBlur}
						/>
						<MimaInput
							type="text"
							labelTitle="Contact Person Email"
							name="contactPersonEmail"
							mb={2}
							value={values.contactPersonEmail}
							onChange={handleChange}
							onBlur={handleBlur}
						/>

						<MimaInput
							type="text"
							labelTitle="Contact Person Mobile"
							name="contactPersonPhone"
							mb={2}
							value={values.contactPersonPhone}
							onChange={handleChange}
							onBlur={handleBlur}
						/>

						<MimaButton
							title="Save"
							loading={loading}
							type="submit"
							onClick={handleSubmit}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default EditVendor;
